<div
  class="background"
  [ngClass]="{'open': isOpen}"
  (click)="toggleSelect()"></div>
<div
  class="select-wrapper"
  [formGroup]="selectFormGroup">
  <ion-item
    [ngClass]="getClass('reasonsInput', 'minLength')"
    (click)="toggleSelect()"
    class="select">
    <ng-content></ng-content>
    <ion-input
      formControlName="reasonsInput"
      class="select-input"
      inputmode="none"
      [value]="reason"
      readonly>
    </ion-input>
    <ion-icon
      class="select-icon"
      name="md-arrow-dropdown"
      slot="end">
    </ion-icon>
  </ion-item>
  <div class="drop-down" [ngClass]="{'open': isOpen}">
    <ion-list *ngIf="reasons && reasons.length">
      <ion-item
        *ngFor="let reasonItem of reasons"
        (click)="select(reasonItem?.deliverySharedReasonNm)">
        {{reasonItem?.deliverySharedReasonNm}}
      </ion-item>
      <ion-item
        lines="none"
        (click)="select('input')">
        <ion-label position="stacked">
          Other (max 75 characters):
        </ion-label>
        <ion-textarea
          formControlName="reasonTextarea"
          [minlength]="3"
          [maxlength]="maxCharacters"
          class="textarea"
          (ionInput)="inputText($event)">
        </ion-textarea>
      </ion-item>
      <div class="share-btn-wrapper">
        <ion-button
          shape="round"
          class="share-button"(click)="isOpen = false">
            Ok
        </ion-button>
      </div>
    </ion-list>
  </div>
</div>

